import React from 'react';

const AuthContext = React.createContext({ authUser: "sam" });

export const AuthConsumer = AuthContext.Consumer;

export default AuthContext;

